export const CURRENCY_STATUS = {
  // From FIAT_ACTIVATION_STATUS_API
  INITIALIZED: 'initialized',
  TNC_ACCEPTED: 'tnc_accepted',
  EDD_ALL_PENDING: 'edd_all_pending',
  EDD_Q1_PENDING: 'edd_q1_pending',
  POA_AUTO_INITIATED: 'poa_auto_initiated',
  POA_AUTO_PENDING: 'poa_auto_pending',
  POA_MANUAL_PENDING: 'poa_manual_pending',
  POA_AUTO_RETRY: 'poa_auto_retry',
  POA_MANUAL_INITIATED: 'poa_manual_initiated',
  POA_MANUAL_RETRY: 'poa_manual_retry',
  POA_FAILED: 'poa_failed',
  POA_APPROVED: 'poa_approved',
  POA_REJECTED: 'poa_rejected',
  FIAT_PENDING: 'fiat_pending',
  FIAT_FAILED: 'fiat_failed',
  FIAT_APPROVED: 'fiat_approved',
} as const;

export type CurrencyStatusType =
  (typeof CURRENCY_STATUS)[keyof typeof CURRENCY_STATUS];

export const EDD_STATUS = {
  PENDING_SUBMIT_ALL: 'pending_submit_all',
  PENDING_SUBMIT_Q1: 'pending_submit_q1',
  SUBMITTED_ALL: 'submitted_all',
  SUBMITTED_Q1: 'submitted_q1',
  APPROVED: 'approved',
  REJECTED: 'rejected',
} as const;

export type EDDStatusType = (typeof EDD_STATUS)[keyof typeof EDD_STATUS];

export const POA_STATUS = {
  PENDING_SUBMIT_AUTO_VERIFICATION: 'pending_submit_auto_verification',
  PENDING_AUTO_VERIFICATION: 'pending_auto_verification',
  PENDING_RETRY_AUTO_VERIFICATION: 'pending_retry_auto_verification',
  PENDING_SUBMIT_MANUAL_REVIEW_ADDRESS_PROOF:
    'pending_submit_manual_review_address_proof',
  PENDING_MANUAL_REVIEW_ADDRESS_PROOF: 'pending_manual_review_address_proof',
  PENDING_RETRY_MANUAL_REVIEW_ADDRESS_PROOF:
    'pending_retry_manual_review_address_proof',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  FAILED: 'failed',
} as const;

export type POAStatusType = (typeof POA_STATUS)[keyof typeof POA_STATUS];

export interface EDDInfo {
  required: boolean;
  status: EDDStatusType;
}

export interface POAInfo {
  required: boolean;
  status: POAStatusType;
  address?: {
    address_line_1: string | null;
    address_line_2: string | null;
    city: string | null;
    country: string | null;
    national_identifier: string | null;
    postcode: string | null;
    state: string | null;
  };
}

export interface CurrencyStatus {
  status: CurrencyStatusType;
  currencyData?: any; // Raw currency data from get-applications
  tncAccepted: boolean;
  isActivated?: boolean;
  edd?: EDDInfo;
  poa?: POAInfo;
  activatedAt?: string;
  rejectionReason?: string;
}

export interface GetCurrenciesResponse {
  data: {
    USD?: CurrencyStatus;
    EUR?: CurrencyStatus;
    GBP?: CurrencyStatus;
    AED?: CurrencyStatus;
  };
  userType: 'retail' | 'institutional' | 'INDIVIDUAL' | 'INSTITUTIONAL';
  timestamp: string;
}
